module.exports = __webpack_public_path__ + "static/media/Architecture_28.77812231.jpg";